import GiftCard from "../../../../src/components/GiftCard";
import * as React from 'react';
export default {
  GiftCard,
  React
};